import { render, staticRenderFns } from "./StudyEnvironmentView.vue?vue&type=template&id=7c486c43&scoped=true"
import script from "./StudyEnvironmentView.vue?vue&type=script&lang=js"
export * from "./StudyEnvironmentView.vue?vue&type=script&lang=js"
import style0 from "./StudyEnvironmentView.vue?vue&type=style&index=0&id=7c486c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c486c43",
  null
  
)

export default component.exports